import { toast } from 'react-hot-toast';
import { BsExclamationTriangleFill } from 'react-icons/bs';
import { FaCheck } from 'react-icons/fa';
import { IoInformationCircle } from 'react-icons/io5';

const Toast = ({ type, msg }) => {
  switch (type) {
    case 'success':
      toast.success(
        <div className="flex items-center gap-2">
          <FaCheck className="text-emerald-700" />
          <span>{msg}</span>
        </div>
      );
      break;
    case 'danger':
      toast.error(
        <div className="flex items-center gap-2">
          <BsExclamationTriangleFill className="text-red-700" />
          <span>{msg}</span>
        </div>
      );
      break;
    case 'warning':
      toast(
        <div className="flex items-center gap-2 text-orange-700">
          <BsExclamationTriangleFill />
          <span>{msg}</span>
        </div>,
        { style: { backgroundColor: 'orange' } }
      );
      break;
    case 'info':
      toast(
        <div className="flex items-center gap-2 text-blue-700">
          <IoInformationCircle />
          <span>{msg}</span>
        </div>,
        { style: { backgroundColor: 'lightblue' } }
      );
      break;
    default:
      break;
  }

  return null; // Ensure component renders nothing as the toast is handled by react-hot-toast
};

export default Toast;
